import React, { useState, useEffect } from "react";
import { updateImageFile } from "../../../../apis/firebase";

import FilePlus from "../../../utils/icons/FilePlus";
import { closePopUp, showAlertPopUp, showPopUp } from "../../../utils/Overlay";

const EDITOR_CONFIG = {
  tools: [
    "adjust",
    "effects",
    "filters",
    "rotate",
    "crop",
    "resize",
    "shapes",
    "text",
  ],
  theme: {
    colors: {
      primaryBg: "#ffffff",
      primaryBgHover: "#f2f2f2",
      secondaryBg: "#F8FAFB",
      secondaryBgHover: "#DFE7ED",
      secondaryBgOpacity: "rgba(255,255,255, 0.75)",
      text: "#5D6D7E",
      textHover: "#1a2329",
      textMute: "#aaa",
      textWarn: "#f7931e",
      accent: "#D5D8DC",
      button: {
        primary: "#666",
        secondary: "#ffffff",
        border: "transparent",
        hover: "#ccc",
        active: "#3a86ff",
      },
      border: "#DFE7ED",
      borderLight: "#e1e1e1",
      disabledBg: "rgba(255, 0, 0, 0.1)",
    },
    fonts: [
      { label: "Arial", value: "Arial" },
      { label: "Tahoma", value: "Tahoma" },
      { label: "Times New Roman", value: "Times New Roman" },
      { label: "Courier", value: "Courier" },
      { label: "Courier New", value: "Courier New" },
      { label: "Verdana", value: "Verdana" },
    ],
  },
  finishButtonLabel: "save",
  // elementId: "image-editor",
  // showInModal: false,
};

export default function OpPhotoManipulation({
  valid,
  message,
  cancel,
  selectedContent,
  post,
  deselect,
}: {
  valid: boolean;
  labelButton?: string;
  message: string;
  cancel: Function;
  post: Post;
  selectedContent: Content[];
  deselect: Function;
}) {
  useEffect(() => {
    let ImageEditor;
    if (valid && selectedContent.length > 0) {
      ImageEditor = new FilerobotImageEditor(EDITOR_CONFIG, {
        onClose() {
          deselect();
        },
        onError() {
          deselect();
          showAlertPopUp("There is a problem editing your photo. Sorry.");
        },
        onComplete(data) {
          data.canvas.toBlob((blob) => {
            showPopUp(
              <UploadTheNewVersion
                blob={blob}
                content={selectedContent[0]}
                post={post}
                cancel={cancel}
              />,
              {
                width: "400px",
              }
            );
          });
        },
        onBeforeComplete() {
          return false;
        },
      });
      ImageEditor.open(selectedContent[0].meta?.url);
    }
    return () => {
      if (ImageEditor) ImageEditor.close();
    };
  }, [valid, selectedContent.length]);
  return valid ? (
    <div id="image-editor"></div>
  ) : (
    <p className="mb1 mt1 tac fz08 with-icon">
      <FilePlus size={16} className="ib" /> {message}
    </p>
  );
}

function UploadTheNewVersion({
  content,
  blob,
  post,
  cancel,
}: {
  content: Content;
  blob: any;
  post: Post;
  cancel: Function;
}) {
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    updateImageFile(
      blob,
      content,
      post,
      () => setProgress(100),
      setProgress,
      setError
    );
  }, []);

  let done = progress === 100;

  return (
    <div>
      <p className="tac mb1">
        {done
          ? "Image successfully updated."
          : error
          ? "There is a problem uploading your image. Sorry, try again."
          : `Saving ${Math.ceil(progress)}%`}
      </p>
      <div className="tac">
        {done || error ? (
          <button
            className="secondary"
            onClick={() => {
              cancel();
              closePopUp();
            }}
          >
            OK
          </button>
        ) : null}
      </div>
    </div>
  );
}
